<template>
  <div class="full">
    <Header />
    <section class="mx-auto text-center my-4 card">
      <p class="font-weight-bold">El examen ha culminado</p>
      <p>
        El 03 de setiembre del presente año, la Unidad de Posgrado a la cual
        está postulando, publicará en sus medios oficiales la relación de
        ingresantes.
      </p>
      <button class="button button--primary" @click="exit()">
        Salir
      </button>
    </section>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

export default {
  components: { Header },
  methods: {
    exit() {
      this.$router.push({
        name: "login"
      });
    },
  },
};
</script>

<style></style>
